export default from './header-title';



// WEBPACK FOOTER //
// ./app/components/header-title/index.js